var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "close-sl",
  "use": "close-sl-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"close-sl\">\n  <polygon points=\"14 1.4 12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4 12.6 14 14 12.6 8.4 7\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id